module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-sound-manager u-hide"
  }, _vm._l((_vm.sounds), function(item) {
    return _c('audio', {
      staticClass: "js-player",
      class: 'js-player-' + item.id,
      attrs: {
        "src": item.src,
        "data-id": item.id,
        "loop": item.loop
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1b36532"}!./src/scripts/components/app-sound-manager/template.html
// module id = 204
// module chunks = 0